import { Trans } from "@lingui/macro";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import React from "react";
import { useToggle } from "react-use";

import { GmClientFragment, ProductDetailsFragment, ProductVariantFragment } from "@/saleor/api";

import SelectClientDialog from "./SelectClientDialog";

export interface AddCheckoutClientButtonProps {
	clients?: GmClientFragment[];
	onClose?: () => void;
	selectedVariant?: ProductVariantFragment | null | undefined;
}

const AddCheckoutClientButton = ({
	clients,
	onClose,
	selectedVariant,
}: AddCheckoutClientButtonProps) => {
	const [isSelectOpen, toggleSelectDialog] = useToggle(false);

	const handleClose = () => {
		toggleSelectDialog();
		onClose && onClose();
	};

	return (
		<>
			<Button
				size="small"
				color="primary"
				onClick={toggleSelectDialog}
				startIcon={<AddCircleIcon />}
			>
				<Trans>Add new Recipient(s)</Trans>
			</Button>
			{isSelectOpen && (
				<SelectClientDialog
					clients={clients}
					isOpen={isSelectOpen}
					onClose={handleClose}
					onShopForClients={handleClose}
					selectedVariant={selectedVariant}
				/>
			)}
		</>
	);
};

export default AddCheckoutClientButton;
